<template>
    <v-container>
        <v-card v-if="showForm">
            <v-card-title class="yellow white--text">{{approvalRequired ? "Request Access" : "Create Account"}}</v-card-title>
            <v-card-text>
                <v-form
                        :lazy-validation="false"
                        ref="form"
                        v-model="formValid"
                >
                    <v-text-field
                            :rules="formRules.name"
                            @keydown="keyDownHandler"
                            id="name-field"
                            label="Name"
                            required
                            v-model="registrationData.name"
                    ></v-text-field>

                    <v-text-field
                            :rules="formRules.username"
                            @keydown="keyDownHandler"
                            id="user-field"
                            label="Username"
                            required
                            v-model="registrationData.username"
                    ></v-text-field>
<!-- 
                    <v-text-field
                            :rules="formRules.address1"
                            @keydown="keyDownHandler"
                            id="address1-field"
                            label="Address 1"
                            required
                            v-model="registrationData.address1"
                    ></v-text-field>

                    <v-text-field
                            :rules="formRules.address2"
                            @keydown="keyDownHandler"
                            id="address2-field"
                            label="Address 2"
                            required
                            v-model="registrationData.address2"
                    ></v-text-field>

                    <v-text-field
                            :rules="formRules.city"
                            @keydown="keyDownHandler"
                            id="city-field"
                            label="City"
                            required
                            v-model="registrationData.city"
                    ></v-text-field>

                    <v-select
                            :items="states"
                            item-text="name"
                            item-value="code"
                            label="State"
                            persistent-hint
                            return-object
                            single-line
                            :rules="formRules.state"
                            required
                            v-model="registrationData.state"
                    ></v-select>
-->
                    <v-text-field
                            :rules="formRules.zip"
                            @keydown="keyDownHandler"
                            id="zip-field"
                            label="Zip Code"
                            required
                            v-model="registrationData.zip"
                    ></v-text-field>

                    <v-text-field
                            :rules="formRules.email"
                            @keydown="keyDownHandler"
                            label="E-mail"
                            required
                            v-model="registrationData.email"
                    ></v-text-field>

                    <v-text-field
                            :rules="formRules.mobile"
                            @keydown="keyDownHandler"
                            label="Mobile #"
                            required
                            v-model="registrationData.mobile"
                    ></v-text-field>

                    <label>Notification Preference</label>
                    <v-select
                            :items="notificationTypes"
                            item-text="name"
                            item-value="code"
                            label="Notification Preference"
                            persistent-hint
                            return-object
                            single-line
                            v-model="registrationData.notificationPreference"
                    ></v-select>

                    <v-text-field
                            :rules="formRules.password"
                            @keydown="keyDownHandler"
                            label="Password"
                            required
                            type="password"
                            v-if="!approvalRequired"
                            v-model="registrationData.password"
                    ></v-text-field>

                    <v-text-field
                            :rules="formRules.passwordConfirm"
                            @keydown="keyDownHandler"
                            label="Confirm"
                            required
                            type="password"
                            v-if="!approvalRequired"
                            v-model="registrationData.passwordConfirm"
                    ></v-text-field>

                    <v-card class="mb-4" v-bind:key="i" v-for="(cat,i) in registrationData.attributes">
                        <v-card-title class="primary white--text mb-4">{{cat.name}} Preference(s)</v-card-title>
                        <v-card-text>
                            <v-chip :color="attr.selected ? 'primary' : 'default'"
                                    :key="j" @click="attr.selected = !attr.selected" class="ma-2"
                                    small
                                    style="cursor:pointer"
                                    v-for="(attr,j) in cat.values">
                                {{attr.name}}
                            </v-chip>
                        </v-card-text>
                    </v-card>

                    <v-btn
                            :disabled="!formValid || executing"
                            @click="register"
                            class="mr-4 white--text"
                            color="green"
                    >
                        Submit
                    </v-btn>

                </v-form>
            </v-card-text>
        </v-card>
        <v-card v-if="!showForm">
            <v-card-title class="yellow white--text">Thank You</v-card-title>
            <v-card-text>
                {{submitMessage}}
            </v-card-text>
        </v-card>

        <v-dialog max-width="290" persistent v-model="errorDialog">
            <v-card>
                <v-card-title class="error white--text">Error</v-card-title>
                <v-card-text>{{errorText}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="errorDialog = false" color="green darken-1" text>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
    import api from "../services/aggrega8-api"
    export default {
        computed: {
            executing: function () {
                return this.$store.state.executing
            },
            selectedProgram: function () {
                return this.$store.state.selectedProgram
            },
            approvalRequired: function() {
                if (this.selectedProgram && this.selectedProgram.accessCode) return false
                else return true
            }
        },
        data() {
            return {
                showForm: true,
                submitMessage: "",
                formValid: true,
                validForm: true,
                errorDialog: false,
                errorText: "",
                registrationData: {
                    name: '',
                    username: '',
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    zip: '',
                    mobile: '',
                    latitude: null,
                    longitude: null,
                    formattedAddress: null,
                    email: '',
                    notificationPreference: {code:"E"},
                    password: '',
                    passwordConfirm: '',
                    orderGuideId: null,
                    attributes: [],
                    selectedProgram: null
                },
                notificationTypes: [
                    {code: "E", name: "E-Mail"},
                    {code: "S", name: "Text/SMS"},
                    {code: "B", name: "Both"}
                ],
                states: [
                    {code: 'AL', name: 'Alabama'},
                    {code: 'AK', name: 'Alaska'},
                    {code: 'AZ', name: 'Arizona'},
                    {code: 'AR', name: 'Arkansas'},
                    {code: 'CA', name: 'California'},
                    {code: 'CO', name: 'Colorado'},
                    {code: 'CT', name: 'Connecticut'},
                    {code: 'DC', name: 'District of Columbia'},
                    {code: 'DE', name: 'Delaware'},
                    {code: 'FL', name: 'Florida'},
                    {code: 'GA', name: 'Georgia'},
                    {code: 'HI', name: 'Hawaii'},
                    {code: 'ID', name: 'Idaho'},
                    {code: 'IL', name: 'Illinois'},
                    {code: 'IN', name: 'Indiana'},
                    {code: 'IA', name: 'Iowa'},
                    {code: 'KS', name: 'Kansas'},
                    {code: 'KY', name: 'Kentucky'},
                    {code: 'LA', name: 'Louisiana'},
                    {code: 'ME', name: 'Maine'},
                    {code: 'MD', name: 'Maryland'},
                    {code: 'MA', name: 'Massachusetts'},
                    {code: 'MI', name: 'Michigan'},
                    {code: 'MN', name: 'Minnesota'},
                    {code: 'MS', name: 'Mississippi'},
                    {code: 'MO', name: 'Missouri'},
                    {code: 'MT', name: 'Montana'},
                    {code: 'NE', name: 'Nebraska'},
                    {code: 'NV', name: 'Nevada'},
                    {code: 'NH', name: 'New Hampshire'},
                    {code: 'NJ', name: 'New Jersey'},
                    {code: 'NM', name: 'New Mexico'},
                    {code: 'NY', name: 'New York'},
                    {code: 'NC', name: 'North Carolina'},
                    {code: 'ND', name: 'North Dakota'},
                    {code: 'OH', name: 'Ohio'},
                    {code: 'OK', name: 'Oklahoma'},
                    {code: 'OR', name: 'Oregon'},
                    {code: 'PA', name: 'Pennsylvania'},
                    {code: 'RI', name: 'Rhode Island'},
                    {code: 'SC', name: 'South Carolina'},
                    {code: 'SD', name: 'South Dakota'},
                    {code: 'TN', name: 'Tennessee'},
                    {code: 'TX', name: 'Texas'},
                    {code: 'UT', name: 'Utah'},
                    {code: 'VT', name: 'Vermont'},
                    {code: 'VA', name: 'Virginia'},
                    {code: 'WA', name: 'Washington'},
                    {code: 'WV', name: 'West Virginia'},
                    {code: 'WI', name: 'Wisconsin'},
                    {code: 'WY', name: 'Wyoming'}
                ],
                formRules: {
                    name: [
                        v => !!v || 'Name is required'
                    ],
                    /*address1: [
                        v => !!v || 'Address 1 is required'
                    ],
                    city: [
                        v => !!v || 'City is required'
                    ],
                    state: [
                        v => !!v || 'State is required'
                    ],*/
                    username: [
                        v => !!v || 'Username is required'
                    ],
                    zip: [
                        v => !!v || 'Zip is required'
                    ],
                    mobile: [
                        v => !!v || 'Mobile is required'
                    ],
                    email: [
                        v => !!v || 'E-mail is required',
                        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                    ],
                    password: [
                        v => !!v || 'New password is required',
                        v => {
                            let error = ''
                            error += (v && v.length < 8 && 'be at least 8 characters') || ''
                            error += (!v.match("(.*)[0-9](.*)") && ((error != '' && ', ') || '') + 'contain at least one number') || ''
                            error += (!v.match("^(.*)[a-z](.*)") && ((error != '' && ', ') || '') + 'contain at least one lowercase character') || ''
                            error += (!v.match("^(.*)[A-Z](.*)") && ((error != '' && ', ') || '') + 'contain at least one uppercase character') || ''
                            error += (!v.match("(.*)[^a-zA-Z0-9](.*)") && ((error != '' && ', ') || '') + 'contain at least one symbol') || ''
                            return (error != '') ? 'Password must ' + error : true
                        }
                    ],
                    passwordConfirm: [
                        v => !!v || 'Password Confirmation is required',
                        v => v == this.registrationData.password || 'Password Confirmation must match'
                    ],

                },
                checkbox: false,
                lazy: false,
            }
        },
        mounted() {
            /*api.get("/consumer/getAttributes/").then(
            (results) => {
                this.guideResults = results.data
                this.registrationData.orderGuideId = results.data.id
                //this.processAttrs()
            },
            (error) => {
                if (error.response.status == 404) {
                    this.codeError = true
                }
            })*/
            let el = document.getElementById("name-field")
            if (el) el.focus()
        },
        beforeDestroy() {

        },
        methods: {
            getCategory(cat) {
                let found = null
                for (let i = 0; i < this.registrationData.attributes.length; i++) {
                    let category = this.registrationData.attributes[i]
                    if (category.name == cat) found = category
                }
                if (!found) {
                    found = {name: cat, values: []}
                    this.registrationData.attributes.push(found)
                }
                return found
            },
            processAttrs() {
                for (let i = 0; i < this.guideResults.attrs.length; i++) {
                    let attr = this.guideResults.attrs[i]
                    let cat = this.getCategory(attr.category)
                    cat.values.push({id: attr.id, name: attr.name, selected: false})
                }
                for (let i = 0; i < this.registrationData.attributes.length; i++) {
                    let cat = this.registrationData.attributes[i]
                    cat.values.sort(((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)))
                }
            },
            keyDownHandler(k) {
                if (k.keyCode !== 13) return
                if (!this.valid) {
                    return
                }
                this.register()
            },
            validate() {
                if (this.$refs.form.validate()) {
                    this.snackbar = true
                }
            },

            register() {
                this.$store.dispatch("setExecuting", true)
                this.$geocoder.setDefaultMode("address")
                let addr = { address_line_1: this.registrationData.address1,
                    address_line_2: this.registrationData.address2,
                    city: this.registrationData.city,
                    state: this.registrationData.state.code,
                    zip_code: this.registrationData.zip,
                    country: 'United States'
                }
                this.$geocoder.send(addr, response => {
                    this.registrationData.latitude = response.results[0].geometry.location.lat
                    this.registrationData.longitude = response.results[0].geometry.location.lng
                    this.registrationData.formattedAddress = response.results[0].formatted_address
                    this.registrationData.selectedProgram = this.selectedProgram
                    api.post("/consumer/createAccount", this.registrationData).then(
                    (results) => {
                        if (results.data.status == "OK") {
                            this.$store.dispatch("setApiKey", results.data.access_token)
                            this.$router.push("/")
                        }
                        else {
                            this.showForm = false
                            this.submitMessage = results.data.message
                        }
                    },
                    (error) => {
                        this.errorText = error.response.data
                        this.errorDialog = true
                    }).then(() => {
                        this.$store.dispatch("setExecuting", false)
                    })
                });
            }
        },
    }
</script>
